import { useQuery } from "@apollo/client";
import { GET_USER } from "api/query";
import type { GetUserQuery, GetUserQueryVariables } from "graphql/generated";

export const useUser = () => {
  const { data, loading, error, refetch } = useQuery<
    GetUserQuery,
    GetUserQueryVariables
  >(GET_USER);

  const user = data?.getUser;
  const hasMfa = (user?.mfaMethods?.length ?? 0) > 0;

  return { user, hasMfa, loading, error, refetch };
};
